
const CryptoJS = require("@/common/libs/crypto-js");

//密钥
let key = "";
let iv = CryptoJS.enc.Utf8.parse("EU5H62G9ICGRNI43");
const aesEncrypt = {
  setKey(val) {
    key = CryptoJS.enc.Utf8.parse(val);
  },
  getKey() {
    return key;
  },
  encrypt(message) {
    let srcs = CryptoJS.enc.Utf8.parse(message);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
  },
  decrypt(message) {
    let decrypt = CryptoJS.AES.decrypt(message, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
  }
};

let MD5 = function(str) {
  return CryptoJS.MD5(str)
    .toString()
    .toUpperCase();
};

let BASE64_EN = function(str) {
  return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(str));
};

let BASE64_DE = function(str) {
  return CryptoJS.enc.Base64.parse(str).toString(CryptoJS.enc.Utf8);

};

export { aesEncrypt, MD5, BASE64_EN, BASE64_DE };
